export default __webpack_public_path__ + "static/media/eleven.bbf52d0e.svg";